import React from 'react';
import PropTypes from 'prop-types';
import { Switch, NavLink } from 'react-router-dom';

import Tab from '../Tab';

import './style.scss';

const TabProp = (props, propName, componentName) => {
	const prop = props[propName];
	return prop.type !== Tab && new Error(`'${componentName}' only accepts 'Tab' as children.`);
};

const Tabs = ({ reverse = false, children }) => {
	const renderLabel = (el, index) => {
		if (!el) {
			return null;
		}
		return (
			<NavLink key={'tab-button-' + index} to={el.props.to || el.props.path} exact activeClassName="active">
				{el.props.title}
			</NavLink>
		);
	};

	const renderContent = () => {
		return <Switch>{children}</Switch>;
	};

	if (reverse) {
		children = children.reverse();
	}

	return (
		<div className="tabs">
			<div className="tabs-bar">{children.map((el, index) => renderLabel(el, index))}</div>
			<div className="tabs-content">{renderContent()}</div>
		</div>
	);
};

Tabs.propTypes = {
	children: PropTypes.oneOfType([TabProp, PropTypes.arrayOf(TabProp)]),
	reverse: PropTypes.bool
};

export default Tabs;
